import { UIText3 } from '@cian/ui-kit';

import { type FC } from 'react';

import styles from './TimeLabel.css';

interface ITimeLabelProps {
  added: string;
  humanizedTime: string;
}

export const TimeLabel: FC<ITimeLabelProps> = props => {
  const { humanizedTime, added } = props;

  return (
    <div className={styles['container']} data-testid="card.time-label">
      <div className={styles['relative']} data-testid="card.humanized-time">
        <UIText3 color="gray60_100">{humanizedTime}</UIText3>
      </div>
      <div className={styles['absolute']} data-testid="card.publication-date">
        <UIText3 color="gray60_100">{added}</UIText3>
      </div>
    </div>
  );
};
